import { Star } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const testimonials = [
  {
    name: "Mariana S.",
    detail: "34 anos • São Paulo",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&h=160&fit=crop&crop=faces&q=80",
    quote:
      "Sempre comecei dietas na segunda e desistia na sexta. Com o método dos 5 passos, completei minha primeira semana sem sofrimento — e já estou na quarta.",
  },
  {
    name: "Carla R.",
    detail: "28 anos • Belo Horizonte",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=160&h=160&fit=crop&crop=faces&q=80",
    quote:
      "O capítulo do cardápio semanal mudou minha rotina. Em 20 minutos de domingo eu planejo a semana inteira, sem ingrediente impossível.",
  },
  {
    name: "Fernanda L.",
    detail: "41 anos • Curitiba",
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=160&h=160&fit=crop&crop=faces&q=80",
    quote:
      "Livro curto, direto, sem enrolação. Li numa tarde e no dia seguinte já montei meu prato de um jeito completamente diferente.",
  },
];

export default function Testimonials() {
  return (
    <section id="depoimentos" data-testid="testimonials-section" className="bg-mint/50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <Eyebrow className="text-terracotta">Quem já aplicou o método</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl">
              Leitoras que saíram do zero e{" "}
              <span className="italic text-terracotta">encontraram o equilíbrio</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className={`flex h-full flex-col rounded-3xl border border-linen bg-white p-8 shadow-sm transition-transform duration-300 hover:-translate-y-1.5 ${
                  i === 1 ? "lg:-translate-y-4 lg:shadow-md" : ""
                }`}
              >
                <div className="flex gap-1" aria-label="5 de 5 estrelas">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={16} className="fill-ochre text-ochre" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-ink">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3 border-t border-linen pt-5">
                  <img
                    src={t.photo}
                    alt={`Foto de ${t.name}`}
                    data-testid={`testimonial-photo-${i + 1}`}
                    className="h-11 w-11 rounded-full object-cover ring-2 ring-mint"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-bold text-ink">{t.name}</p>
                    <p className="text-xs text-moss">{t.detail}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
